module.exports = __webpack_public_path__ + "img/Hoja_Izquierda.5be09f0e.svg";